import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useProjectStore } from '../../stores/projectStore';
import ProjectsHistory from '../projects/ProjectsHistory';

const PROJECTS_COUNT = 3;

const ProjectsSection: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const { projects, fetchProjects } = useProjectStore();

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  const visibleProjects = projects.slice(0, PROJECTS_COUNT);

  return (
    <ProjectsHistory
      historyProjects={visibleProjects}
      variant="dashboard"
      title={t('dashboard:projects.title')}
    />
  );
};

export default ProjectsSection;
